// admin/src/lib/equipmentClass.ts
//
// Wave 10 spec §3 Lane D: "Equipment: a multi-select from the equipment
// library with photos, orderable (sort). Never an upload here. On save,
// exercises.equipment = the first item's class (or 'none'/'bodyweight'
// when empty, matching sport)."

import type { EquipmentClass, LoadMode } from './vocab';

export type EquipmentChoice = { equipment_id: string; class: EquipmentClass; sort: number };

/**
 * Derives the coarse `exercises.equipment` value from the exercise's
 * ordered equipment picks. The first pick (by `sort`) wins. With no picks
 * at all, a bodyweight-loaded exercise defaults to 'bodyweight' and
 * everything else to 'none' -- both valid `exercises_equipment_check`
 * values (migration 0013).
 */
export function deriveEquipmentClass(
  picks: readonly EquipmentChoice[],
  loadMode: LoadMode,
): EquipmentClass {
  if (picks.length === 0) {
    return loadMode === 'bodyweight' ? 'bodyweight' : 'none';
  }
  const first = [...picks].sort((a, b) => a.sort - b.sort)[0];
  return first.class;
}
